import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { Handle, type NodeProps, Position, useStore } from 'reactflow';
import { AddStepButton } from 'src/pages/Settings/workflows/components/add-step-button';
import { WorkflowAddStepMenu } from 'src/pages/Settings/workflows/components/workflow-add-step-menu';
import type { WorkflowAddStepNodeData } from 'src/pages/Settings/workflows/utils/workflow-helpers';

const NODE_WIDTH = 280;
const NODE_HEIGHT = 56;

const hiddenHandleStyle = { opacity: 0, border: 'none' } as const;

/**
 * The small + at the end of a path, to add a step there. Across the page it is as tall as the step
 * it follows and level with it, so the + and the connection sit on that step's middle line.
 */
const AddStepNodeComponent = ({ data }: NodeProps<WorkflowAddStepNodeData>) => {
  const sourceHeight = useStore(
    (state) => state.nodeInternals.get(data.insertion.sourceId)?.height ?? undefined,
  );
  const height = data.horizontal ? (sourceHeight ?? NODE_HEIGHT) : NODE_HEIGHT;

  return (
    <Box className="nodrag nopan">
      <Handle
        type="target"
        position={data.horizontal ? Position.Left : Position.Top}
        style={hiddenHandleStyle}
        isConnectable={false}
      />
      <WorkflowAddStepMenu
        insertion={data.insertion}
        renderTrigger={(state) => (
          <Stack
            width={NODE_WIDTH}
            height={height}
            // the + sits where the connection arrives: top centre, or middle left across the page
            alignItems={data.horizontal ? 'flex-start' : 'center'}
            justifyContent={data.horizontal ? 'center' : 'flex-start'}
          >
            <AddStepButton {...state} label="Add a step" />
          </Stack>
        )}
      />
    </Box>
  );
};

export const AddStepNode = memo(AddStepNodeComponent);
